import { useState, useCallback } from 'react'
import { buildReplyContext } from '@/lib/reply'
import type { Post, ReplyContext } from '@/types/posts'

export function useReplyModal() {
    const [replyContext, setReplyContext] = useState<ReplyContext | null>(null)

    const handleReply = useCallback((post: Post) => {
        const ctx = buildReplyContext(post)
        if (ctx) setReplyContext(ctx)
    }, [])

    const closeReply = useCallback(() => setReplyContext(null), [])

    return { replyContext, handleReply, closeReply }
}
